import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img 
              src="/logo.png" 
              alt="Prince Edward School Crest" 
              className="footer-logo"
            />
            <h3>Prince Edward School Rugby</h3>
            <p>The Tigers</p>
            <p>Jubilee Field, Harare, Zimbabwe</p>
          </div>
          <div className="footer-section">
            <h4>Established</h4>
            <p>13 June 1898</p>
          </div>
          <div className="footer-section">
            <h4>Colours</h4>
            <p>Maroon, Green & White</p>
          </div>
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a 
                href="https://www.facebook.com/Tigers1898/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link facebook"
                aria-label="Visit our Facebook page"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                <span>Facebook</span>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 1898 Prince Edward School Rugby. Preserving tradition, building character, shaping futures.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

